import useIsDesktop from '@/shared/hooks/useIsDesktop';
import {
  OnboardingSideContainer,
  FieldTitle,
} from '@/shared/styles/styledComponents/styledComponents';
import styled from '@emotion/native';
import React from 'react';
import { openImagePicker } from '@/shared/utils';
import { GalleryImages } from '@/shared/types/stylist';
import useStore from '@/stores/useStore';
import GalleryLayout from '@/shared/components/GalleryLayout';
import SentryService from '@/services/sentry/Sentry.service';
import { mint } from '@/shared/styles/colors';
import { ASPECT_RATIOS } from '@/shared/styles/constants';
import { IsDesktopProps } from '@/shared/styles/types';

interface Props {
  images: GalleryImages;
  setImages: (arg: GalleryImages) => void;
}

const Showcase = ({ images, setImages }: Props) => {
  const { setSnackbarState } = useStore();
  const isDesktop = useIsDesktop();

  const onLandscapePress = async () => {
    try {
      const image = await openImagePicker(ASPECT_RATIOS.LANDSCAPE);
      if (image) {
        setImages({ ...images, landscapeImage: image });
      }
    } catch (error) {
      SentryService.captureError('Error updating landscape image', error);
      setSnackbarState({
        open: true,
        message: 'Error updating landscape image, please try again.',
        severity: 'error',
      });
    }
    return;
  };

  const onPortraitPress = async (index: number) => {
    try {
      const image = await openImagePicker(ASPECT_RATIOS.PORTRAIT);
      if (image) {
        const newPortraitImages = [...images.portraitImages];
        newPortraitImages[index] = image;
        setImages({ ...images, portraitImages: newPortraitImages });
      }
    } catch (error) {
      SentryService.captureError('Error updating portrait image', error);
      setSnackbarState({
        open: true,
        message: 'Error updating portrait image, please try again.',
        severity: 'error',
      });
    }
    return;
  };

  const onAddPortraitImage = async () => {
    try {
      const image = await openImagePicker(ASPECT_RATIOS.PORTRAIT);
      if (image) {
        setImages({
          ...images,
          portraitImages: [...images.portraitImages, image],
        });
      }
    } catch (error) {
      SentryService.captureError('Error adding portrait image', error);
      setSnackbarState({
        open: true,
        message: 'Error adding portrait image, please try again.',
        severity: 'error',
      });
    }
    return;
  };

  return (
    <OuterContainer isDesktop={isDesktop}>
      {isDesktop && <FieldTitle marginBottom={26}>Profile Gallery*</FieldTitle>}
      <InnerContainer isDesktop={isDesktop}>
        <GalleryLayout
          galleryImages={images}
          onSelectLandscapeImage={onLandscapePress}
          onSelectPortraitImage={onPortraitPress}
          onAddPortraitImage={onAddPortraitImage}
          isDesktop={isDesktop}
          backgroundColor={mint}
        />
      </InnerContainer>
    </OuterContainer>
  );
};

const OuterContainer = styled(OnboardingSideContainer)({});

const InnerContainer = styled.View<IsDesktopProps>(({ isDesktop }) => ({
  paddingHorizontal: isDesktop ? 80 : 0,
}));

export default Showcase;
